// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__155Rs","short":"styles_short__1ZJjV","word":"styles_word__1yvBM","used":"styles_used__2Lxib","hidden":"styles_hidden__1rtK7"};